import GraphQLClientServer from './graphQLClientServer';

if (typeof window !== 'undefined') {
    window.JsonGraphqlServer = GraphQLClientServer;
}

export default GraphQLClientServer;



// WEBPACK FOOTER //
// ./src/client.js